module.exports = __webpack_public_path__ + "img/icon_overtime_4.24175579.svg";